window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  const hideSkipOnSkip = () => {
    // Intercept fetch requests to skip endpoint
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const [url, options] = args;

      // Check if this is a skip request - match pattern: https://shapi.bundlepayments.com/customers/{customerId}/subscriptions/{subscriptionId}/skip
      if (typeof url === "string" && /^https:\/\/shapi\.bundlepayments\.com\/customers\/\d+\/subscriptions\/\d+\/skip/.test(url)) {
        return originalFetch.apply(this, args).then(async (response) => {
          if (response.ok) {
            const clonedResponse = response.clone();
            try {
              const data = await clonedResponse.json();
              // Check if the response indicates successful skip
              if (data?.subscriptionContract?.CustomAttributes) {
                const skippedAttr = data.subscriptionContract.CustomAttributes.find((a) => a?.key === "skipped");
                if (skippedAttr) {
                  document.body.classList.add("cp-skip-hidden");
                }
              }
            } catch (e) {
              // If parsing fails, still return the original response
            }
          }
          return response;
        });
      }

      return originalFetch.apply(this, args);
    };
  };

  const observer = new MutationObserver(() => {
    const dateStr = window?.Awtomic?.subscriptionDetails?.NextBillingDate;
    if (!dateStr) return;

    observer.disconnect();

    const inputDate = new Date(dateStr);
    const now = new Date();
    const thirtyDaysLater = new Date(now.getTime() + 30 * 86400000); // 30 days in ms

    if (inputDate > now && inputDate < thirtyDaysLater) {
      document.body.classList.add("cp-cancel-hidden");
    }

    const attrs = window?.Awtomic?.subscriptionDetails?.CustomAttributes;
    if (Array.isArray(attrs)) {
      const skippedAttr = attrs.find((a) => a?.key === "skipped");
      const val = skippedAttr?.value ?? skippedAttr?.typed_value ?? skippedAttr?.stringValue ?? skippedAttr;
      if (val === true || val === "true" || String(val).toLowerCase() === "true") {
        document.body.classList.add("cp-skip-hidden");
      } else {
        hideSkipOnSkip();
      }
    } else {
      hideSkipOnSkip();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  waitForElement(".awtomatic-plans-container", (plansContainer) => {
    if (plansContainer.children.length <= 1) {
      plansContainer.style.display = "none";

      const previousElement = plansContainer.previousElementSibling;
      if (previousElement && previousElement.tagName.toLowerCase() === "span" && previousElement.classList.contains("bundle-text--subheading")) {
        previousElement.style.display = "none";
      }
    }
  });
}

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});
